
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"35","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".682","y":"1.098","width":"11","height":"8","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('path',{attrs:{"d":"M11.967 16.52H2.592l-.852 1.062.867 1.078h9.36v1.11H3.482l1.164 1.367-.507.43-3.743-3.735v-.5l3.743-3.734.507.43-1.171 1.382h8.492v1.11z","fill":"currentColor"}})])
          )
        }
      }
    